import { MainContentLayout } from 'shared/ui/layout';

import { AddOcpiHub } from 'features/ocpi-hub/add';

export function AddOcpiHubPage() {
  return <MainContentLayout element={<AddOcpiHub />} />;
}
